<script lang="ts">
  import { linkTo } from "$lib/utils/url";
  export let link: string;
  export let label: string;
  export let target: string = "_self";
  export let block: boolean = false;
  export let isHovered: boolean = false;
  export let fullHeight: boolean = false;
  $: hoverState = isHovered;
</script>

<style lang="scss">
  .block {
    display: block;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .sfc-link {
    &--full-height {
      height: 100%;
    }
  }
</style>

{#if link}
  <a
    class="sfc-link {fullHeight && 'sfc-link--full-height'}"
    class:hoverState
    class:block
    href={linkTo(link)}
    {target}
    aria-label={label}
  >
    <span class="sr-only">{label}</span>
    <slot />
  </a>
{:else}
  <slot />
{/if}
